import React from "react";

function MinusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="2"
      viewBox="0 0 9 2"
      fill="none"
    >
      <path d="M9 1.5H0V0.5H9V1.5Z" fill="black" />
    </svg>
  );
}

export default MinusIcon;
